import httpManager from "@/app/shared/utils/httpManager";

export async function downloadRecord(cdrId) {
  const url = `/pbx/cdr/${cdrId}/download/`;
  const response = await httpManager.getBlob(url);
  return response?.data;
}
